import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDJ9GQDk0Tndaj7ZI4wDlJoYNNThQuB72I",
  authDomain: "iglekids-2a7b4.firebaseapp.com",
  projectId: "iglekids-2a7b4",
  storageBucket:  "iglekids-2a7b4.firebasestorage.app",
  messagingSenderId: "485793425771",
  appId: "1:485793425771:web:80552108d64668bb10442e"
};

// Inicializamos la conexión
const app = initializeApp(firebaseConfig);

// Exportamos las herramientas para usarlas en los Contextos
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);